document.addEventListener("DOMContentLoaded", function () {
      const siteHeader = document.querySelector(".site-header");
      const headerInner = document.querySelector(".site-header-inner");
      const prefersReducedMotion = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
      const partnershipUrl = "https://dpn.deeper.network/pages/dpn-app-cooperation-information";
      document.querySelectorAll("a.button").forEach(function (link) {
        const label = (link.textContent || "").replace(/\s+/g, " ").trim().toUpperCase();
        if (label.includes("JOIN PARTNERSHIP") || link.getAttribute("href") === "#join-partnership" || (link.href || "").includes("information@deeper.network")) {
          link.href = partnershipUrl;
        }
      });
      const topHeaderRestoreStyle = document.createElement("style");
      topHeaderRestoreStyle.id = "dpn-reseller-top-header-restore";
      topHeaderRestoreStyle.textContent = `
        @media (min-width: 901px) {
          body .site-header:not(.is-floating) {
            height: 75px !important;
            padding: 0 !important;
            color: #fff !important;
            background: #000 !important;
            box-shadow: none !important;
            backdrop-filter: none !important;
            -webkit-backdrop-filter: none !important;
          }

          body .site-header:not(.is-floating) .site-header-inner {
            display: grid !important;
            grid-template-columns: 290px minmax(0, 1fr) 120px !important;
            width: min(var(--nav-max), calc(100% - 112px)) !important;
            height: 74px !important;
            min-height: 74px !important;
            margin: 0 auto !important;
            padding: 0 !important;
            border: 0 !important;
            border-radius: 0 !important;
            color: #fff !important;
            background: transparent !important;
            box-shadow: none !important;
            backdrop-filter: none !important;
            -webkit-backdrop-filter: none !important;
            transform: none !important;
          }

          body .site-header:not(.is-floating) .site-nav-menu {
            gap: 24px !important;
            color: #fff !important;
            font-size: 16px !important;
            font-weight: 700 !important;
            line-height: 22px !important;
          }

          body .site-header:not(.is-floating) .site-nav-item,
          body .site-header:not(.is-floating) .site-nav-link,
          body .site-header:not(.is-floating) .site-nav-menu > a,
          body .site-header:not(.is-floating) .site-icon {
            min-height: 74px !important;
            height: 74px !important;
          }

          body .site-header:not(.is-floating) .site-nav-link,
          body .site-header:not(.is-floating) .site-nav-menu > a {
            padding: 0 !important;
            color: #fff !important;
            font-size: 16px !important;
            font-weight: 700 !important;
            line-height: 22px !important;
          }

          body .site-header:not(.is-floating) .site-nav-item--guide .site-nav-link {
            width: auto !important;
            max-width: none !important;
            justify-content: center !important;
            text-align: center !important;
          }

          body .site-header:not(.is-floating) .site-actions {
            width: auto !important;
            min-width: 0 !important;
          }

          body .site-header:not(.is-floating) .site-icon {
            width: 40px !important;
            flex: 0 0 40px !important;
            color: #fff !important;
          }
        }
      `;
      document.head.appendChild(topHeaderRestoreStyle);
      const headerPolishStyle = document.createElement("style");
      headerPolishStyle.id = "dpn-reseller-header-runtime-polish";
      headerPolishStyle.textContent = `
        @media (min-width: 901px) {
          .site-header {
            z-index: 320 !important;
          }

          .site-header:not(.is-floating) .site-dropdown.site-dropdown--products.site-dropdown--vpn-products {
            top: var(--reseller-header-bottom, 120px) !important;
            transform: translate3d(0, -8px, 0) scale(0.985) !important;
          }

          .site-header:not(.is-floating) .has-dropdown:hover > .site-dropdown.site-dropdown--products.site-dropdown--vpn-products,
          .site-header:not(.is-floating) .has-dropdown:focus-within > .site-dropdown.site-dropdown--products.site-dropdown--vpn-products {
            transform: translate3d(0, 0, 0) scale(1) !important;
          }

          .site-header:not(.is-floating) .site-dropdown.site-dropdown--products.site-dropdown--bundle-products {
            width: min(960px, calc(100vw - 96px)) !important;
          }

          .site-header:not(.is-floating) .site-dropdown.site-dropdown--products.site-dropdown--bundle-products .site-dropdown-inner {
            grid-template-columns: 250px minmax(0, 1fr) !important;
            gap: 28px !important;
            padding: 22px !important;
            border-color: rgba(255, 255, 255, 0.15) !important;
            color: #fff !important;
            background:
              radial-gradient(circle at 86% 8%, rgba(72, 128, 255, 0.16), transparent 34%),
              linear-gradient(180deg, rgba(20, 20, 20, 0.98), rgba(0, 0, 0, 0.98)) !important;
            box-shadow:
              0 28px 58px rgba(0, 0, 0, 0.34),
              inset 0 1px 0 rgba(255, 255, 255, 0.08) !important;
            backdrop-filter: blur(18px) saturate(150%) !important;
            -webkit-backdrop-filter: blur(18px) saturate(150%) !important;
          }

          .site-header:not(.is-floating) .site-dropdown.site-dropdown--products.site-dropdown--bundle-products .site-dropdown-group strong,
          .site-header:not(.is-floating) .site-dropdown.site-dropdown--products.site-dropdown--bundle-products .site-dropdown-group a,
          .site-header:not(.is-floating) .site-dropdown.site-dropdown--products.site-dropdown--bundle-products .dropdown-product-title {
            color: rgba(255, 255, 255, 0.94) !important;
          }

          .site-header:not(.is-floating) .site-dropdown.site-dropdown--products.site-dropdown--bundle-products .site-dropdown-group a {
            color: rgba(255, 255, 255, 0.72) !important;
          }

          .site-dropdown.site-dropdown--products.site-dropdown--bundle-products .dropdown-product-grid.dropdown-product-grid--bundles {
            grid-template-columns: repeat(3, 184px) !important;
            justify-content: start !important;
            gap: 16px !important;
          }

          .site-dropdown.site-dropdown--products.site-dropdown--bundle-products .dropdown-product-card {
            min-height: 266px !important;
            padding: 0 !important;
            border-radius: 10px !important;
            grid-template-rows: 166px auto !important;
            gap: 8px !important;
          }

          .site-header:not(.is-floating) .site-dropdown.site-dropdown--products.site-dropdown--bundle-products .dropdown-product-card {
            border-color: rgba(255, 255, 255, 0.15) !important;
            background: linear-gradient(180deg, #171717 0%, #0c0c0c 100%) !important;
            box-shadow: none !important;
          }

          .site-dropdown.site-dropdown--products.site-dropdown--bundle-products .dropdown-product-image {
            height: 166px !important;
            padding: 20px 16px 0 !important;
            border-radius: 0 !important;
            background: transparent !important;
          }

          .site-dropdown.site-dropdown--products.site-dropdown--bundle-products .dropdown-product-image img {
            width: auto !important;
            max-width: 92% !important;
            max-height: 132px !important;
            margin: 0 auto !important;
            object-fit: contain !important;
          }

          .site-dropdown.site-dropdown--products.site-dropdown--bundle-products .dropdown-product-title {
            max-width: 160px !important;
            min-height: 38px !important;
            margin: 0 auto !important;
            padding: 0 12px 20px !important;
            font-size: 16px !important;
            line-height: 1.12 !important;
            font-weight: 500 !important;
            text-align: center !important;
          }

          .site-header.is-floating .site-header-inner {
            grid-template-columns: 210px minmax(0, 1fr) 112px !important;
            width: min(1368px, calc(100% - 48px)) !important;
            padding: 0 22px !important;
          }

          .site-header.is-floating .site-nav-menu {
            gap: clamp(9px, 0.78vw, 14px) !important;
            font-size: 15px !important;
            font-weight: 600 !important;
          }

          .site-header.is-floating .site-nav-item {
            flex: 0 1 auto !important;
          }

          .site-header.is-floating .site-nav-item--guide {
            flex: 0 1 190px !important;
          }

          .site-header.is-floating .site-nav-item--guide .site-nav-link {
            width: 190px !important;
            max-width: 190px !important;
            justify-content: center !important;
            text-align: center !important;
          }

          .site-header.is-floating .site-actions {
            width: 112px !important;
            min-width: 112px !important;
          }

          .site-header.is-floating .site-icon {
            width: 34px !important;
            flex-basis: 34px !important;
          }

          .site-dropdown--vpn-products {
            z-index: 340 !important;
            background: #000 !important;
            backdrop-filter: none !important;
            -webkit-backdrop-filter: none !important;
          }

          .site-dropdown--vpn-products::before {
            content: "" !important;
            position: absolute !important;
            inset: 0 !important;
            z-index: 0 !important;
            background: #000 !important;
            pointer-events: none !important;
          }

          .site-dropdown--vpn-products .site-dropdown-inner {
            position: relative !important;
            z-index: 1 !important;
          }

          .site-header.is-floating .site-dropdown--vpn-products {
            top: 102px !important;
            background: rgba(255, 255, 255, 0.98) !important;
            backdrop-filter: blur(24px) saturate(165%) !important;
            -webkit-backdrop-filter: blur(24px) saturate(165%) !important;
          }

          .site-header.is-floating .site-dropdown--vpn-products::before {
            background: rgba(255, 255, 255, 0.98) !important;
          }

          .site-dropdown--vpn-products .site-dropdown-inner,
          .site-header.is-floating .site-dropdown--vpn-products .site-dropdown-inner {
            width: min(1284px, calc(100vw - 96px)) !important;
            grid-template-columns: 220px minmax(0, 1fr) !important;
            gap: 28px !important;
          }

          .site-dropdown--vpn-products .site-dropdown-group strong,
          .site-header.is-floating .site-dropdown--vpn-products .site-dropdown-group strong {
            font-size: 22px !important;
            line-height: 1.12 !important;
            font-weight: 600 !important;
          }

          .site-dropdown--vpn-products .site-dropdown-group a,
          .site-header.is-floating .site-dropdown--vpn-products .site-dropdown-group a {
            font-size: 15px !important;
            line-height: 1.42 !important;
            font-weight: 400 !important;
            text-decoration: none !important;
          }

          .site-dropdown--vpn-products .dropdown-product-grid {
            grid-template-columns: repeat(5, 184px) !important;
            justify-content: start !important;
            gap: 16px !important;
          }

          .site-dropdown--vpn-products .dropdown-product-card,
          .site-header.is-floating .site-dropdown--vpn-products .dropdown-product-card {
            align-items: center !important;
            min-height: 266px !important;
            border-radius: 9px !important;
            text-decoration: none !important;
          }

          .site-dropdown--vpn-products .dropdown-product-image,
          .site-header.is-floating .site-dropdown--vpn-products .dropdown-product-image {
            height: 166px !important;
            padding: 20px 16px 0 !important;
            place-items: center !important;
          }

          .site-dropdown--vpn-products .dropdown-product-image img {
            max-width: 92% !important;
            max-height: 132px !important;
          }

          .site-dropdown--vpn-products .dropdown-product-copy {
            justify-items: center !important;
            gap: 8px !important;
            padding: 0 14px 21px !important;
          }

          .site-dropdown--vpn-products .dropdown-product-title,
          .site-header.is-floating .site-dropdown--vpn-products .dropdown-product-title {
            max-width: 160px !important;
            min-height: 38px !important;
            font-size: 16px !important;
            line-height: 1.12 !important;
            font-weight: 500 !important;
            text-align: center !important;
            display: -webkit-box !important;
            -webkit-box-orient: vertical !important;
            -webkit-line-clamp: 2 !important;
            overflow: hidden !important;
            text-decoration: none !important;
          }

          .site-dropdown--vpn-products .dropdown-product-subtitle,
          .site-header.is-floating .site-dropdown--vpn-products .dropdown-product-subtitle {
            max-width: 164px !important;
            font-size: 13px !important;
            line-height: 1.18 !important;
            font-weight: 400 !important;
            text-align: center !important;
            text-decoration: none !important;
          }

          .site-dropdown.site-dropdown--products.site-dropdown--vpn-products {
            background: #000 !important;
          }

          .site-dropdown.site-dropdown--products.site-dropdown--vpn-products .site-dropdown-inner,
          .site-header.is-floating .site-dropdown.site-dropdown--products.site-dropdown--vpn-products .site-dropdown-inner {
            width: min(1284px, calc(100vw - 96px)) !important;
            grid-template-columns: 220px minmax(0, 1fr) !important;
            gap: 28px !important;
          }

          .site-dropdown.site-dropdown--products.site-dropdown--vpn-products .dropdown-product-grid.dropdown-product-grid--vpn {
            grid-template-columns: repeat(5, 184px) !important;
            justify-content: start !important;
            gap: 16px !important;
          }

          .site-dropdown.site-dropdown--products.site-dropdown--vpn-products .dropdown-product-grid.dropdown-product-grid--vpn > .dropdown-product-card {
            width: 184px !important;
            min-height: 266px !important;
            border-radius: 9px !important;
          }

          .site-dropdown.site-dropdown--products.site-dropdown--vpn-products .dropdown-product-grid.dropdown-product-grid--vpn > .dropdown-product-card .dropdown-product-title {
            font-size: 16px !important;
            line-height: 1.12 !important;
            font-weight: 500 !important;
          }

          .site-header.is-floating .site-dropdown.site-dropdown--products.site-dropdown--vpn-products {
            left: 50% !important;
            right: auto !important;
            top: 82px !important;
            width: min(1320px, calc(100vw - 120px)) !important;
            max-width: calc(100vw - 120px) !important;
            padding: 26px 30px 30px !important;
            border: 1px solid rgba(126, 184, 255, 0.32) !important;
            border-radius: 28px !important;
            background:
              radial-gradient(circle at 16% 0%, rgba(231, 245, 255, 0.92), transparent 36%),
              linear-gradient(180deg, rgba(255, 255, 255, 0.98), rgba(246, 251, 255, 0.96)) !important;
            box-shadow:
              0 34px 90px rgba(15, 23, 42, 0.16),
              0 1px 0 rgba(255, 255, 255, 0.9) inset !important;
            overflow: hidden !important;
            transform: translate3d(-50%, -8px, 0) scale(0.985) !important;
            transform-origin: 50% 0 !important;
          }

          .site-header.is-floating .site-dropdown.site-dropdown--products.site-dropdown--vpn-products::before {
            border-radius: inherit !important;
            background:
              linear-gradient(90deg, rgba(255, 255, 255, 0.94), rgba(255, 255, 255, 0.72)),
              radial-gradient(circle at 88% 8%, rgba(37, 120, 255, 0.12), transparent 32%) !important;
          }

          .site-header.is-floating .has-dropdown:hover > .site-dropdown.site-dropdown--products.site-dropdown--vpn-products,
          .site-header.is-floating .has-dropdown:focus-within > .site-dropdown.site-dropdown--products.site-dropdown--vpn-products {
            opacity: 1 !important;
            visibility: visible !important;
            pointer-events: auto !important;
            transform: translate3d(-50%, 0, 0) scale(1) !important;
          }

          .site-header.is-floating .site-dropdown.site-dropdown--products.site-dropdown--vpn-products .site-dropdown-inner {
            width: 100% !important;
            max-width: none !important;
            margin: 0 !important;
          }

          .site-header.is-floating .site-dropdown.site-dropdown--products.site-dropdown--vpn-products {
            position: fixed !important;
            top: 82px !important;
            left: 50% !important;
            right: auto !important;
            box-sizing: border-box !important;
            width: min(1320px, calc(100vw - 96px)) !important;
            max-width: calc(100vw - 96px) !important;
            padding: 26px 30px 30px !important;
            border: 1px solid rgba(126, 184, 255, 0.32) !important;
            border-radius: 28px !important;
            background:
              radial-gradient(circle at 16% 0%, rgba(231, 245, 255, 0.92), transparent 36%),
              radial-gradient(circle at 88% 8%, rgba(37, 120, 255, 0.12), transparent 32%),
              linear-gradient(180deg, rgba(255, 255, 255, 0.98), rgba(246, 251, 255, 0.96)) !important;
            box-shadow:
              0 34px 90px rgba(15, 23, 42, 0.16),
              0 1px 0 rgba(255, 255, 255, 0.9) inset !important;
            overflow: hidden !important;
            transform: translate3d(-50%, -8px, 0) scale(0.985) !important;
            transform-origin: 50% 0 !important;
            backdrop-filter: blur(24px) saturate(165%) !important;
            -webkit-backdrop-filter: blur(24px) saturate(165%) !important;
          }

          .site-header.is-floating .site-dropdown.site-dropdown--products.site-dropdown--vpn-products::before {
            inset: 0 !important;
            border-radius: inherit !important;
            background: linear-gradient(90deg, rgba(255, 255, 255, 0.94), rgba(255, 255, 255, 0.72)) !important;
          }

          .site-header.is-floating .has-dropdown:hover > .site-dropdown.site-dropdown--products.site-dropdown--vpn-products,
          .site-header.is-floating .has-dropdown:focus-within > .site-dropdown.site-dropdown--products.site-dropdown--vpn-products {
            opacity: 1 !important;
            visibility: visible !important;
            pointer-events: auto !important;
            transform: translate3d(-50%, 0, 0) scale(1) !important;
          }

          .site-header.is-floating .site-dropdown.site-dropdown--products.site-dropdown--vpn-products .site-dropdown-inner {
            width: 100% !important;
            max-width: none !important;
            margin: 0 !important;
            padding: 0 !important;
            border: 0 !important;
            border-radius: 0 !important;
            background: transparent !important;
            box-shadow: none !important;
            grid-template-columns: 220px minmax(0, 1fr) !important;
            gap: 28px !important;
            backdrop-filter: none !important;
            -webkit-backdrop-filter: none !important;
          }

          .site-header.is-floating .site-dropdown.site-dropdown--products.site-dropdown--vpn-products .dropdown-product-grid.dropdown-product-grid--vpn {
            grid-template-columns: repeat(5, minmax(0, 1fr)) !important;
            gap: 16px !important;
            justify-content: stretch !important;
          }

          .site-header.is-floating .site-dropdown.site-dropdown--products.site-dropdown--vpn-products .dropdown-product-grid.dropdown-product-grid--vpn > .dropdown-product-card {
            width: auto !important;
            min-width: 0 !important;
            min-height: 266px !important;
            border-radius: 10px !important;
          }
        }
      `;
      document.head.appendChild(headerPolishStyle);

      const headerPlacementStyle = document.createElement("style");
      headerPlacementStyle.id = "dpn-reseller-header-placement-lock";
      headerPlacementStyle.textContent = `
        @media (min-width: 901px) {
          .site-header:not(.is-floating) .site-dropdown.site-dropdown--products.site-dropdown--vpn-products,
          .site-header:not(.is-floating) .site-dropdown.site-dropdown--products.site-dropdown--bundle-products,
          .site-header.is-floating .site-dropdown.site-dropdown--products.site-dropdown--vpn-products,
          .site-header.is-floating .site-dropdown.site-dropdown--products.site-dropdown--bundle-products {
            position: fixed !important;
            top: calc(var(--reseller-header-bottom, 102px) + 8px) !important;
            left: 50% !important;
            right: auto !important;
            box-sizing: border-box !important;
            padding-top: 0 !important;
            transform: translate3d(-50%, -8px, 0) scale(0.985) !important;
            transform-origin: 50% 0 !important;
            z-index: 340 !important;
          }

          .site-header:not(.is-floating) .has-dropdown:hover > .site-dropdown.site-dropdown--products.site-dropdown--vpn-products,
          .site-header:not(.is-floating) .has-dropdown:focus-within > .site-dropdown.site-dropdown--products.site-dropdown--vpn-products,
          .site-header:not(.is-floating) .has-dropdown:hover > .site-dropdown.site-dropdown--products.site-dropdown--bundle-products,
          .site-header:not(.is-floating) .has-dropdown:focus-within > .site-dropdown.site-dropdown--products.site-dropdown--bundle-products,
          .site-header.is-floating .has-dropdown:hover > .site-dropdown.site-dropdown--products.site-dropdown--vpn-products,
          .site-header.is-floating .has-dropdown:focus-within > .site-dropdown.site-dropdown--products.site-dropdown--vpn-products,
          .site-header.is-floating .has-dropdown:hover > .site-dropdown.site-dropdown--products.site-dropdown--bundle-products,
          .site-header.is-floating .has-dropdown:focus-within > .site-dropdown.site-dropdown--products.site-dropdown--bundle-products {
            transform: translate3d(-50%, 0, 0) scale(1) !important;
          }

          .site-header:not(.is-floating) .site-dropdown.site-dropdown--products.site-dropdown--vpn-products {
            width: min(1320px, calc(100vw - 96px)) !important;
            max-width: calc(100vw - 96px) !important;
          }

          .site-header:not(.is-floating) .site-dropdown.site-dropdown--products.site-dropdown--bundle-products,
          .site-header.is-floating .site-dropdown.site-dropdown--products.site-dropdown--bundle-products {
            width: min(960px, calc(100vw - 96px)) !important;
            max-width: calc(100vw - 96px) !important;
          }

          .site-header.is-floating .site-dropdown.site-dropdown--products.site-dropdown--bundle-products {
            top: 82px !important;
          }

          .site-header:not(.is-floating) .site-dropdown.site-dropdown--products.site-dropdown--bundle-products {
            background: transparent !important;
          }

          .site-header.is-floating .site-dropdown.site-dropdown--products.site-dropdown--bundle-products .site-dropdown-inner {
            grid-template-columns: 250px minmax(0, 1fr) !important;
            gap: 28px !important;
            padding: 22px !important;
            border-color: rgba(126, 184, 255, 0.25) !important;
            background: rgba(255, 255, 255, 0.94) !important;
            box-shadow:
              0 24px 60px rgba(15, 23, 42, 0.12),
              inset 0 1px 0 rgba(255, 255, 255, 0.76) !important;
          }
        }
      `;
      document.head.appendChild(headerPlacementStyle);
      const topHeaderRestoreFinalStyle = topHeaderRestoreStyle.cloneNode(true);
      topHeaderRestoreFinalStyle.id = "dpn-reseller-top-header-restore-final";
      document.head.appendChild(topHeaderRestoreFinalStyle);
      const roundedPopoverStyle = document.createElement("style");
      roundedPopoverStyle.id = "dpn-reseller-rounded-popover-lock";
      roundedPopoverStyle.textContent = `
        @media (min-width: 901px) {
          .site-header {
            --reseller-popover-edge: 48px;
            --reseller-popover-gap: 10px;
            --reseller-popover-radius: 28px;
            --reseller-popover-pad: 24px;
            --reseller-small-popover-radius: 22px;
            --reseller-small-popover-pad: 16px;
          }

          .site-header .site-dropdown {
            box-sizing: border-box !important;
            padding-top: var(--reseller-popover-gap) !important;
          }

          .site-header .site-dropdown:not(.site-dropdown--products) .site-dropdown-inner {
            box-sizing: border-box !important;
            padding: var(--reseller-small-popover-pad) !important;
            border-radius: var(--reseller-small-popover-radius) !important;
            overflow: hidden !important;
          }

          .site-header:not(.is-floating) .site-dropdown:not(.site-dropdown--products) .site-dropdown-inner {
            border-color: rgba(255, 255, 255, 0.16) !important;
            background:
              radial-gradient(circle at 82% 0%, rgba(58, 126, 255, 0.16), transparent 38%),
              linear-gradient(180deg, rgba(20, 20, 20, 0.98), rgba(0, 0, 0, 0.98)) !important;
            box-shadow:
              0 28px 64px rgba(0, 0, 0, 0.34),
              inset 0 1px 0 rgba(255, 255, 255, 0.08) !important;
          }

          .site-header.is-floating .site-dropdown:not(.site-dropdown--products) .site-dropdown-inner {
            border-color: rgba(126, 184, 255, 0.28) !important;
            background:
              radial-gradient(circle at 82% 0%, rgba(219, 240, 255, 0.82), transparent 38%),
              linear-gradient(180deg, rgba(255, 255, 255, 0.96), rgba(246, 251, 255, 0.94)) !important;
            box-shadow:
              0 28px 68px rgba(15, 23, 42, 0.14),
              inset 0 1px 0 rgba(255, 255, 255, 0.82) !important;
          }

          .site-header .site-dropdown.site-dropdown--products {
            position: fixed !important;
            top: calc(var(--reseller-header-bottom, 102px) + var(--reseller-popover-gap)) !important;
            left: 50% !important;
            right: auto !important;
            box-sizing: border-box !important;
            max-width: calc(100vw - (var(--reseller-popover-edge) * 2)) !important;
            padding: var(--reseller-popover-pad) !important;
            border-radius: var(--reseller-popover-radius) !important;
            overflow: hidden !important;
            transform: translate3d(-50%, -8px, 0) scale(0.985) !important;
            transform-origin: 50% 0 !important;
            z-index: 340 !important;
          }

          .site-header .has-dropdown:hover > .site-dropdown.site-dropdown--products,
          .site-header .has-dropdown:focus-within > .site-dropdown.site-dropdown--products {
            transform: translate3d(-50%, 0, 0) scale(1) !important;
          }

          .site-header .site-dropdown.site-dropdown--products::before {
            content: "" !important;
            position: absolute !important;
            inset: 0 !important;
            z-index: 0 !important;
            border-radius: inherit !important;
            background: inherit !important;
            pointer-events: none !important;
          }

          .site-header .site-dropdown.site-dropdown--products .site-dropdown-inner {
            position: relative !important;
            z-index: 1 !important;
            width: 100% !important;
            max-width: none !important;
            margin: 0 !important;
            padding: 0 !important;
            border: 0 !important;
            border-radius: 0 !important;
            background: transparent !important;
            box-shadow: none !important;
            overflow: visible !important;
            backdrop-filter: none !important;
            -webkit-backdrop-filter: none !important;
          }

          .site-header .site-dropdown.site-dropdown--products .dropdown-product-card {
            border-radius: 12px !important;
            overflow: hidden !important;
          }

          .site-header .site-dropdown.site-dropdown--products.site-dropdown--vpn-products {
            width: min(1320px, calc(100vw - (var(--reseller-popover-edge) * 2))) !important;
          }

          .site-header .site-dropdown.site-dropdown--products.site-dropdown--bundle-products {
            width: min(960px, calc(100vw - (var(--reseller-popover-edge) * 2))) !important;
          }

          .site-header:not(.is-floating) .site-dropdown.site-dropdown--products {
            border: 1px solid rgba(255, 255, 255, 0.16) !important;
            background:
              radial-gradient(circle at 86% 8%, rgba(72, 128, 255, 0.16), transparent 34%),
              linear-gradient(180deg, rgba(20, 20, 20, 0.98), rgba(0, 0, 0, 0.98)) !important;
            box-shadow:
              0 30px 72px rgba(0, 0, 0, 0.36),
              inset 0 1px 0 rgba(255, 255, 255, 0.08) !important;
            backdrop-filter: blur(18px) saturate(150%) !important;
            -webkit-backdrop-filter: blur(18px) saturate(150%) !important;
          }

          .site-header.is-floating .site-dropdown.site-dropdown--products {
            border: 1px solid rgba(126, 184, 255, 0.32) !important;
            background:
              radial-gradient(circle at 16% 0%, rgba(231, 245, 255, 0.92), transparent 36%),
              radial-gradient(circle at 88% 8%, rgba(37, 120, 255, 0.12), transparent 32%),
              linear-gradient(180deg, rgba(255, 255, 255, 0.98), rgba(246, 251, 255, 0.96)) !important;
            box-shadow:
              0 34px 90px rgba(15, 23, 42, 0.16),
              inset 0 1px 0 rgba(255, 255, 255, 0.9) !important;
            backdrop-filter: blur(24px) saturate(165%) !important;
            -webkit-backdrop-filter: blur(24px) saturate(165%) !important;
          }
        }
      `;
      document.head.appendChild(roundedPopoverStyle);

      const finalRoundedPopoverStyle = document.createElement("style");
      finalRoundedPopoverStyle.id = "dpn-reseller-rounded-popover-v6-final";
      finalRoundedPopoverStyle.textContent = `
        @media (min-width: 901px) {
          .site-header {
            --reseller-popover-edge: 48px;
            --reseller-popover-gap: 10px;
            --reseller-popover-radius: 26px;
            --reseller-popover-pad: 24px;
            --reseller-small-popover-radius: 22px;
            --reseller-small-popover-pad: 18px;
          }

          .site-header .site-dropdown {
            box-sizing: border-box !important;
            padding-top: var(--reseller-popover-gap) !important;
            background: transparent !important;
            border: 0 !important;
            box-shadow: none !important;
            overflow: visible !important;
          }

          .site-header .site-dropdown:not(.site-dropdown--products) {
            border-radius: var(--reseller-small-popover-radius) !important;
          }

          .site-header .site-dropdown:not(.site-dropdown--products) .site-dropdown-inner {
            box-sizing: border-box !important;
            width: 100% !important;
            padding: var(--reseller-small-popover-pad) !important;
            border-radius: var(--reseller-small-popover-radius) !important;
            overflow: hidden !important;
            background-clip: padding-box !important;
          }

          .site-header .site-dropdown--wide .site-dropdown-inner,
          .site-header .site-dropdown--guide .site-dropdown-inner {
            padding: 20px !important;
            gap: 14px !important;
          }

          .site-header:not(.is-floating) .site-dropdown:not(.site-dropdown--products) .site-dropdown-inner {
            border: 1px solid rgba(255, 255, 255, 0.12) !important;
            background: linear-gradient(180deg, #111318 0%, #05070d 100%) !important;
            box-shadow:
              0 26px 58px rgba(0, 0, 0, 0.34),
              inset 0 1px 0 rgba(255, 255, 255, 0.07) !important;
            backdrop-filter: none !important;
            -webkit-backdrop-filter: none !important;
          }

          .site-header.is-floating .site-dropdown:not(.site-dropdown--products) .site-dropdown-inner {
            border: 1px solid rgba(126, 184, 255, 0.26) !important;
            background:
              radial-gradient(circle at 86% 0%, rgba(225, 244, 255, 0.82), transparent 40%),
              linear-gradient(180deg, rgba(255, 255, 255, 0.98), rgba(247, 251, 255, 0.96)) !important;
            box-shadow:
              0 26px 64px rgba(15, 23, 42, 0.14),
              inset 0 1px 0 rgba(255, 255, 255, 0.88) !important;
            backdrop-filter: blur(22px) saturate(165%) !important;
            -webkit-backdrop-filter: blur(22px) saturate(165%) !important;
          }

          .site-header .site-dropdown:not(.site-dropdown--products) a {
            border-radius: 12px !important;
          }

          .site-header .site-dropdown.site-dropdown--products {
            position: fixed !important;
            top: calc(var(--reseller-header-bottom, 102px) + var(--reseller-popover-gap)) !important;
            left: 50% !important;
            right: auto !important;
            box-sizing: border-box !important;
            max-width: calc(100vw - (var(--reseller-popover-edge) * 2)) !important;
            padding: var(--reseller-popover-pad) !important;
            border-radius: var(--reseller-popover-radius) !important;
            overflow: hidden !important;
            background-clip: padding-box !important;
            isolation: isolate !important;
            transform: translate3d(-50%, -8px, 0) scale(0.985) !important;
            transform-origin: 50% 0 !important;
            z-index: 340 !important;
          }

          .site-header .has-dropdown:hover > .site-dropdown.site-dropdown--products,
          .site-header .has-dropdown:focus-within > .site-dropdown.site-dropdown--products {
            transform: translate3d(-50%, 0, 0) scale(1) !important;
          }

          .site-header .site-dropdown.site-dropdown--products::before {
            content: none !important;
            display: none !important;
          }

          .site-header .site-dropdown.site-dropdown--products .site-dropdown-inner {
            position: relative !important;
            z-index: 1 !important;
            width: 100% !important;
            max-width: none !important;
            margin: 0 !important;
            padding: 0 !important;
            border: 0 !important;
            border-radius: 0 !important;
            background: transparent !important;
            box-shadow: none !important;
            overflow: visible !important;
            backdrop-filter: none !important;
            -webkit-backdrop-filter: none !important;
          }

          .site-header .site-dropdown.site-dropdown--products.site-dropdown--vpn-products {
            width: min(1320px, calc(100vw - (var(--reseller-popover-edge) * 2))) !important;
          }

          .site-header .site-dropdown.site-dropdown--products.site-dropdown--bundle-products {
            width: min(960px, calc(100vw - (var(--reseller-popover-edge) * 2))) !important;
          }

          .site-header .site-dropdown.site-dropdown--products.site-dropdown--bundle-products .site-dropdown-inner {
            grid-template-columns: 250px minmax(0, 1fr) !important;
            gap: 28px !important;
          }

          .site-header:not(.is-floating) .site-dropdown.site-dropdown--products {
            border: 1px solid rgba(255, 255, 255, 0.12) !important;
            background: linear-gradient(180deg, #111318 0%, #05070d 100%) !important;
            box-shadow:
              0 30px 70px rgba(0, 0, 0, 0.36),
              inset 0 1px 0 rgba(255, 255, 255, 0.07) !important;
            backdrop-filter: none !important;
            -webkit-backdrop-filter: none !important;
          }

          .site-header.is-floating .site-dropdown.site-dropdown--products {
            border: 1px solid rgba(126, 184, 255, 0.28) !important;
            background:
              radial-gradient(circle at 12% 0%, rgba(231, 245, 255, 0.9), transparent 38%),
              radial-gradient(circle at 90% 8%, rgba(37, 120, 255, 0.1), transparent 34%),
              linear-gradient(180deg, rgba(255, 255, 255, 0.98), rgba(247, 251, 255, 0.96)) !important;
            box-shadow:
              0 32px 84px rgba(15, 23, 42, 0.15),
              inset 0 1px 0 rgba(255, 255, 255, 0.9) !important;
            backdrop-filter: blur(24px) saturate(165%) !important;
            -webkit-backdrop-filter: blur(24px) saturate(165%) !important;
          }

          .site-header .site-dropdown.site-dropdown--products .dropdown-product-card {
            border-radius: 14px !important;
            overflow: hidden !important;
            background-clip: padding-box !important;
          }
        }
      `;
      document.head.appendChild(finalRoundedPopoverStyle);

      const finalProductPaddingStyle = document.createElement("style");
      finalProductPaddingStyle.id = "dpn-reseller-product-popover-padding-v10";
      finalProductPaddingStyle.textContent = `
        @media (min-width: 901px) {
          .site-header:not(.is-floating) .site-dropdown.site-dropdown--products.site-dropdown--vpn-products,
          .site-header:not(.is-floating) .site-dropdown.site-dropdown--products.site-dropdown--bundle-products,
          .site-header.is-floating .site-dropdown.site-dropdown--products.site-dropdown--vpn-products,
          .site-header.is-floating .site-dropdown.site-dropdown--products.site-dropdown--bundle-products {
            top: calc(var(--reseller-header-bottom, 102px) + var(--reseller-popover-gap)) !important;
            padding: var(--reseller-popover-pad) !important;
            border-radius: var(--reseller-popover-radius) !important;
            overflow: hidden !important;
          }

          .site-header:not(.is-floating) .site-dropdown.site-dropdown--products.site-dropdown--vpn-products .site-dropdown-inner,
          .site-header:not(.is-floating) .site-dropdown.site-dropdown--products.site-dropdown--bundle-products .site-dropdown-inner,
          .site-header.is-floating .site-dropdown.site-dropdown--products.site-dropdown--vpn-products .site-dropdown-inner,
          .site-header.is-floating .site-dropdown.site-dropdown--products.site-dropdown--bundle-products .site-dropdown-inner {
            padding: 0 !important;
            border: 0 !important;
            border-radius: 0 !important;
            background: transparent !important;
            box-shadow: none !important;
          }

          .site-header:not(.is-floating) .site-dropdown.site-dropdown--products.site-dropdown--vpn-products,
          .site-header:not(.is-floating) .site-dropdown.site-dropdown--products.site-dropdown--bundle-products {
            top: 130px !important;
            border: 1px solid rgba(255, 255, 255, 0.12) !important;
            background: linear-gradient(180deg, #111318 0%, #05070d 100%) !important;
            box-shadow:
              0 30px 70px rgba(0, 0, 0, 0.36),
              inset 0 1px 0 rgba(255, 255, 255, 0.07) !important;
            backdrop-filter: none !important;
            -webkit-backdrop-filter: none !important;
          }

          .site-header.is-floating .site-dropdown.site-dropdown--products.site-dropdown--vpn-products,
          .site-header.is-floating .site-dropdown.site-dropdown--products.site-dropdown--bundle-products {
            top: 82px !important;
          }
        }
      `;
      document.head.appendChild(finalProductPaddingStyle);

      const v15NavParityStyle = document.createElement("style");
      v15NavParityStyle.id = "dpn-reseller-nav-parity-v15";
      v15NavParityStyle.textContent = `
        @media (min-width: 901px) {
          body .site-header {
            --reseller-header-shell-height: 102px;
            --reseller-header-frame-height: 72px;
            --reseller-header-edge: 72px;
            --reseller-header-pad-x: 28px;
            --reseller-header-cols: 290px minmax(0, 1fr) 120px;
            --reseller-nav-gap: clamp(10px, 0.95vw, 18px);
            --reseller-nav-font-size: 16px;
            --reseller-nav-font-weight: 600;
            --reseller-popover-gap: 10px;
            --reseller-popover-edge: 48px;
            --reseller-popover-pad: 24px;
            --reseller-popover-radius: 26px;
            --reseller-small-popover-pad: 18px;
            --reseller-small-popover-radius: 22px;
            --reseller-product-card-width: 184px;
            --reseller-product-card-height: 266px;
            --reseller-product-image-height: 166px;
          }

          body .site-header,
          body .site-header:not(.is-floating),
          body .site-header.is-floating {
            position: sticky !important;
            top: 0 !important;
            z-index: 60 !important;
            height: var(--reseller-header-shell-height) !important;
            padding: 30px 0 0 !important;
            overflow: visible !important;
            background: transparent !important;
            box-shadow: none !important;
            backdrop-filter: none !important;
            -webkit-backdrop-filter: none !important;
          }

          body .site-header .site-header-inner,
          body .site-header:not(.is-floating) .site-header-inner,
          body .site-header.is-floating .site-header-inner {
            display: grid !important;
            grid-template-columns: var(--reseller-header-cols) !important;
            align-items: center !important;
            width: min(var(--nav-max), calc(100% - var(--reseller-header-edge))) !important;
            height: var(--reseller-header-frame-height) !important;
            min-height: var(--reseller-header-frame-height) !important;
            margin: 0 auto !important;
            padding: 0 var(--reseller-header-pad-x) !important;
            border-radius: 999px !important;
            transform: none !important;
            overflow: visible !important;
          }

          body .site-header:not(.is-floating) .site-header-inner {
            color: #ffffff !important;
            border: 1px solid rgba(255, 255, 255, 0.16) !important;
            background: linear-gradient(180deg, #101318 0%, #05070d 100%) !important;
            box-shadow:
              0 18px 44px rgba(0, 0, 0, 0.22),
              inset 0 1px 0 rgba(255, 255, 255, 0.08) !important;
            backdrop-filter: none !important;
            -webkit-backdrop-filter: none !important;
          }

          body .site-header.is-floating .site-header-inner {
            color: #121722 !important;
            border: 1px solid rgba(126, 184, 255, 0.36) !important;
            background: rgba(255, 255, 255, 0.78) !important;
            box-shadow:
              0 24px 72px rgba(15, 23, 42, 0.1),
              inset 0 10px 26px rgba(255, 255, 255, 0.36),
              inset 0 1px 0 rgba(255, 255, 255, 0.78) !important;
            backdrop-filter: blur(28px) saturate(180%) contrast(104%) !important;
            -webkit-backdrop-filter: blur(28px) saturate(180%) contrast(104%) !important;
          }

          body .site-header:not(.is-floating) .site-header-inner::before,
          body .site-header:not(.is-floating) .site-header-inner::after,
          body .site-header:not(.is-floating) .header-edge-light {
            display: none !important;
            opacity: 0 !important;
          }

          body .site-header .site-nav-menu,
          body .site-header:not(.is-floating) .site-nav-menu,
          body .site-header.is-floating .site-nav-menu {
            gap: var(--reseller-nav-gap) !important;
            color: inherit !important;
            font-size: var(--reseller-nav-font-size) !important;
            line-height: 22px !important;
            font-weight: var(--reseller-nav-font-weight) !important;
          }

          body .site-header .site-nav-item,
          body .site-header .site-nav-link,
          body .site-header .site-nav-menu > a,
          body .site-header .site-icon,
          body .site-header:not(.is-floating) .site-nav-item,
          body .site-header:not(.is-floating) .site-nav-link,
          body .site-header:not(.is-floating) .site-nav-menu > a,
          body .site-header:not(.is-floating) .site-icon,
          body .site-header.is-floating .site-nav-item,
          body .site-header.is-floating .site-nav-link,
          body .site-header.is-floating .site-nav-menu > a,
          body .site-header.is-floating .site-icon {
            min-height: 70px !important;
            height: 70px !important;
            color: inherit !important;
            font-size: var(--reseller-nav-font-size) !important;
            line-height: 22px !important;
            font-weight: var(--reseller-nav-font-weight) !important;
          }

          body .site-header .site-nav-link,
          body .site-header .site-nav-menu > a,
          body .site-header:not(.is-floating) .site-nav-link,
          body .site-header:not(.is-floating) .site-nav-menu > a,
          body .site-header.is-floating .site-nav-link,
          body .site-header.is-floating .site-nav-menu > a {
            padding: 0 !important;
          }

          body .site-header .site-actions,
          body .site-header:not(.is-floating) .site-actions,
          body .site-header.is-floating .site-actions {
            width: 120px !important;
            min-width: 120px !important;
            justify-content: flex-end !important;
            color: inherit !important;
          }

          body .site-header .site-icon,
          body .site-header:not(.is-floating) .site-icon,
          body .site-header.is-floating .site-icon {
            width: 36px !important;
            flex: 0 0 36px !important;
          }

          body .site-header .site-icon svg,
          body .site-header:not(.is-floating) .site-icon svg,
          body .site-header.is-floating .site-icon svg {
            width: 22px !important;
            height: 22px !important;
          }

          body .site-header .site-logo img,
          body .site-header:not(.is-floating) .site-logo img,
          body .site-header.is-floating .site-logo img {
            width: 150px !important;
            height: auto !important;
          }

          body .site-header .site-dropdown {
            box-sizing: border-box !important;
            padding-top: var(--reseller-popover-gap) !important;
            border: 0 !important;
            background: transparent !important;
            box-shadow: none !important;
            overflow: visible !important;
          }

          body .site-header .site-dropdown:not(.site-dropdown--products) .site-dropdown-inner {
            box-sizing: border-box !important;
            padding: var(--reseller-small-popover-pad) !important;
            border-radius: var(--reseller-small-popover-radius) !important;
            overflow: hidden !important;
            background-clip: padding-box !important;
          }

          body .site-header .site-dropdown--wide .site-dropdown-inner,
          body .site-header .site-dropdown--guide .site-dropdown-inner {
            padding: var(--reseller-small-popover-pad) !important;
            gap: 16px !important;
          }

          body .site-header:not(.is-floating) .site-dropdown:not(.site-dropdown--products) .site-dropdown-inner {
            color: #ffffff !important;
            border: 1px solid rgba(255, 255, 255, 0.12) !important;
            background: linear-gradient(180deg, #111318 0%, #05070d 100%) !important;
            box-shadow:
              0 26px 58px rgba(0, 0, 0, 0.34),
              inset 0 1px 0 rgba(255, 255, 255, 0.07) !important;
            backdrop-filter: none !important;
            -webkit-backdrop-filter: none !important;
          }

          body .site-header.is-floating .site-dropdown:not(.site-dropdown--products) .site-dropdown-inner {
            color: #111318 !important;
            border: 1px solid rgba(126, 184, 255, 0.26) !important;
            background:
              radial-gradient(circle at 86% 0%, rgba(225, 244, 255, 0.82), transparent 40%),
              linear-gradient(180deg, rgba(255, 255, 255, 0.98), rgba(247, 251, 255, 0.96)) !important;
            box-shadow:
              0 26px 64px rgba(15, 23, 42, 0.14),
              inset 0 1px 0 rgba(255, 255, 255, 0.88) !important;
            backdrop-filter: blur(22px) saturate(165%) !important;
            -webkit-backdrop-filter: blur(22px) saturate(165%) !important;
          }

          body .site-header .site-dropdown strong,
          body .site-header:not(.is-floating) .site-dropdown strong,
          body .site-header.is-floating .site-dropdown strong {
            font-size: 13px !important;
            line-height: 1.25 !important;
            font-weight: 600 !important;
          }

          body .site-header .site-dropdown a,
          body .site-header:not(.is-floating) .site-dropdown a,
          body .site-header.is-floating .site-dropdown a {
            font-size: 13px !important;
            line-height: 1.35 !important;
            font-weight: 500 !important;
          }

          body .site-header:not(.is-floating) .site-dropdown strong {
            color: rgba(255, 255, 255, 0.94) !important;
          }

          body .site-header:not(.is-floating) .site-dropdown a {
            color: rgba(255, 255, 255, 0.72) !important;
          }

          body .site-header.is-floating .site-dropdown strong {
            color: #111318 !important;
          }

          body .site-header.is-floating .site-dropdown a {
            color: rgba(17, 19, 24, 0.66) !important;
          }

          body .site-header .site-dropdown.site-dropdown--products,
          body .site-header:not(.is-floating) .site-dropdown.site-dropdown--products,
          body .site-header.is-floating .site-dropdown.site-dropdown--products {
            position: fixed !important;
            top: calc(var(--reseller-header-bottom, 102px) + var(--reseller-popover-gap)) !important;
            left: 50% !important;
            right: auto !important;
            box-sizing: border-box !important;
            max-width: calc(100vw - (var(--reseller-popover-edge) * 2)) !important;
            padding: var(--reseller-popover-pad) !important;
            border-radius: var(--reseller-popover-radius) !important;
            overflow: hidden !important;
            background-clip: padding-box !important;
            isolation: isolate !important;
            transform: translate3d(-50%, -8px, 0) scale(0.985) !important;
            transform-origin: 50% 0 !important;
            z-index: 340 !important;
          }

          body .site-header .has-dropdown:hover > .site-dropdown.site-dropdown--products,
          body .site-header .has-dropdown:focus-within > .site-dropdown.site-dropdown--products {
            opacity: 1 !important;
            visibility: visible !important;
            pointer-events: auto !important;
            transform: translate3d(-50%, 0, 0) scale(1) !important;
          }

          body .site-header .site-dropdown.site-dropdown--products::before {
            content: none !important;
            display: none !important;
          }

          body .site-header:not(.is-floating) .site-dropdown.site-dropdown--products {
            color: #ffffff !important;
            border: 1px solid rgba(255, 255, 255, 0.12) !important;
            background: linear-gradient(180deg, #111318 0%, #05070d 100%) !important;
            box-shadow:
              0 30px 70px rgba(0, 0, 0, 0.36),
              inset 0 1px 0 rgba(255, 255, 255, 0.07) !important;
            backdrop-filter: none !important;
            -webkit-backdrop-filter: none !important;
          }

          body .site-header.is-floating .site-dropdown.site-dropdown--products {
            color: #111318 !important;
            border: 1px solid rgba(126, 184, 255, 0.28) !important;
            background:
              radial-gradient(circle at 12% 0%, rgba(231, 245, 255, 0.9), transparent 38%),
              radial-gradient(circle at 90% 8%, rgba(37, 120, 255, 0.1), transparent 34%),
              linear-gradient(180deg, rgba(255, 255, 255, 0.98), rgba(247, 251, 255, 0.96)) !important;
            box-shadow:
              0 32px 84px rgba(15, 23, 42, 0.15),
              inset 0 1px 0 rgba(255, 255, 255, 0.9) !important;
            backdrop-filter: blur(24px) saturate(165%) !important;
            -webkit-backdrop-filter: blur(24px) saturate(165%) !important;
          }

          body .site-header .site-dropdown.site-dropdown--products.site-dropdown--vpn-products {
            width: min(1320px, calc(100vw - (var(--reseller-popover-edge) * 2))) !important;
          }

          body .site-header .site-dropdown.site-dropdown--products.site-dropdown--bundle-products {
            width: min(960px, calc(100vw - (var(--reseller-popover-edge) * 2))) !important;
          }

          body .site-header .site-dropdown.site-dropdown--products .site-dropdown-inner,
          body .site-header:not(.is-floating) .site-dropdown.site-dropdown--products .site-dropdown-inner,
          body .site-header.is-floating .site-dropdown.site-dropdown--products .site-dropdown-inner {
            position: relative !important;
            z-index: 1 !important;
            width: 100% !important;
            max-width: none !important;
            margin: 0 !important;
            padding: 0 !important;
            border: 0 !important;
            border-radius: 0 !important;
            background: transparent !important;
            box-shadow: none !important;
            overflow: visible !important;
            backdrop-filter: none !important;
            -webkit-backdrop-filter: none !important;
          }

          body .site-header .site-dropdown.site-dropdown--products.site-dropdown--vpn-products .site-dropdown-inner {
            grid-template-columns: 220px minmax(0, 1fr) !important;
            gap: 28px !important;
          }

          body .site-header .site-dropdown.site-dropdown--products.site-dropdown--bundle-products .site-dropdown-inner {
            grid-template-columns: 250px minmax(0, 1fr) !important;
            gap: 28px !important;
          }

          body .site-header .site-dropdown.site-dropdown--products .dropdown-product-grid,
          body .site-header .site-dropdown.site-dropdown--products .dropdown-product-grid--vpn {
            grid-template-columns: repeat(5, var(--reseller-product-card-width)) !important;
            justify-content: start !important;
            gap: 16px !important;
          }

          body .site-header .site-dropdown.site-dropdown--products .dropdown-product-grid--bundles {
            grid-template-columns: repeat(3, var(--reseller-product-card-width)) !important;
            justify-content: start !important;
            gap: 16px !important;
          }

          body .site-header .site-dropdown.site-dropdown--products .dropdown-product-card,
          body .site-header:not(.is-floating) .site-dropdown.site-dropdown--products .dropdown-product-card,
          body .site-header.is-floating .site-dropdown.site-dropdown--products .dropdown-product-card {
            display: flex !important;
            flex-direction: column !important;
            justify-content: space-between !important;
            width: var(--reseller-product-card-width) !important;
            min-height: var(--reseller-product-card-height) !important;
            height: var(--reseller-product-card-height) !important;
            padding: 0 !important;
            border-radius: 14px !important;
            overflow: hidden !important;
            text-align: center !important;
            text-decoration: none !important;
            background-clip: padding-box !important;
            transform: translate3d(0, 0, 0) !important;
          }

          body .site-header:not(.is-floating) .site-dropdown.site-dropdown--products .dropdown-product-card {
            border: 1px solid rgba(255, 255, 255, 0.09) !important;
            color: rgba(255, 255, 255, 0.94) !important;
            background: linear-gradient(180deg, rgba(255, 255, 255, 0.09), rgba(255, 255, 255, 0.045)) !important;
            box-shadow: none !important;
          }

          body .site-header.is-floating .site-dropdown.site-dropdown--products .dropdown-product-card {
            border: 1px solid rgba(36, 120, 255, 0.1) !important;
            color: #111318 !important;
            background: linear-gradient(180deg, rgba(248, 252, 255, 0.96), rgba(239, 247, 255, 0.9)) !important;
            box-shadow: none !important;
          }

          body .site-header .site-dropdown.site-dropdown--products .dropdown-product-card:hover,
          body .site-header .site-dropdown.site-dropdown--products .dropdown-product-card:focus-visible {
            transform: translate3d(0, -4px, 0) !important;
          }

          body .site-header:not(.is-floating) .site-dropdown.site-dropdown--products .dropdown-product-card:hover,
          body .site-header:not(.is-floating) .site-dropdown.site-dropdown--products .dropdown-product-card:focus-visible {
            border-color: rgba(255, 255, 255, 0.18) !important;
            background: linear-gradient(180deg, rgba(255, 255, 255, 0.13), rgba(255, 255, 255, 0.06)) !important;
          }

          body .site-header.is-floating .site-dropdown.site-dropdown--products .dropdown-product-card:hover,
          body .site-header.is-floating .site-dropdown.site-dropdown--products .dropdown-product-card:focus-visible {
            border-color: rgba(36, 120, 255, 0.22) !important;
            background: linear-gradient(180deg, #ffffff, #eef7ff) !important;
            box-shadow: 0 18px 34px rgba(31, 96, 176, 0.12) !important;
          }

          body .site-header .site-dropdown.site-dropdown--products .dropdown-product-image,
          body .site-header:not(.is-floating) .site-dropdown.site-dropdown--products .dropdown-product-image,
          body .site-header.is-floating .site-dropdown.site-dropdown--products .dropdown-product-image {
            display: grid !important;
            height: var(--reseller-product-image-height) !important;
            padding: 20px 16px 0 !important;
            place-items: center !important;
            border-radius: 0 !important;
            background: transparent !important;
            overflow: hidden !important;
          }

          body .site-header .site-dropdown.site-dropdown--products .dropdown-product-image img,
          body .site-header:not(.is-floating) .site-dropdown.site-dropdown--products .dropdown-product-image img,
          body .site-header.is-floating .site-dropdown.site-dropdown--products .dropdown-product-image img {
            width: auto !important;
            max-width: 92% !important;
            height: auto !important;
            max-height: 132px !important;
            margin: 0 auto !important;
            object-fit: contain !important;
          }

          body .site-header .site-dropdown.site-dropdown--products .dropdown-product-copy {
            display: grid !important;
            justify-items: center !important;
            gap: 8px !important;
            padding: 0 14px 21px !important;
          }

          body .site-header .site-dropdown.site-dropdown--products .dropdown-product-title,
          body .site-header:not(.is-floating) .site-dropdown.site-dropdown--products .dropdown-product-title,
          body .site-header.is-floating .site-dropdown.site-dropdown--products .dropdown-product-title {
            max-width: 160px !important;
            min-height: 38px !important;
            margin: 0 auto !important;
            padding: 0 12px 20px !important;
            color: inherit !important;
            font-size: 16px !important;
            line-height: 1.12 !important;
            font-weight: 500 !important;
            text-align: center !important;
            display: -webkit-box !important;
            -webkit-box-orient: vertical !important;
            -webkit-line-clamp: 2 !important;
            overflow: hidden !important;
            text-decoration: none !important;
          }

          body .site-header .site-dropdown.site-dropdown--products .dropdown-product-copy .dropdown-product-title {
            padding: 0 !important;
          }

          body .site-header .site-dropdown.site-dropdown--products .dropdown-product-subtitle,
          body .site-header:not(.is-floating) .site-dropdown.site-dropdown--products .dropdown-product-subtitle,
          body .site-header.is-floating .site-dropdown.site-dropdown--products .dropdown-product-subtitle {
            max-width: 164px !important;
            font-size: 13px !important;
            line-height: 1.18 !important;
            font-weight: 400 !important;
            text-align: center !important;
            text-decoration: none !important;
            white-space: normal !important;
          }

          body .site-header:not(.is-floating) .site-dropdown.site-dropdown--products .dropdown-product-subtitle {
            color: rgba(255, 255, 255, 0.56) !important;
          }

          body .site-header.is-floating .site-dropdown.site-dropdown--products .dropdown-product-subtitle {
            color: rgba(17, 19, 24, 0.5) !important;
          }
        }
      `;
      document.head.appendChild(v15NavParityStyle);

      const v151SpecificityStyle = document.createElement("style");
      v151SpecificityStyle.id = "dpn-reseller-nav-parity-v15-1";
      v151SpecificityStyle.textContent = `
        @media (min-width: 901px) {
          body.dpn-app-reseller-template .site-header:not(.is-floating) .site-header-inner,
          body.dpn-app-reseller-template .site-header.is-floating .site-header-inner {
            box-sizing: border-box !important;
            height: var(--reseller-header-frame-height) !important;
            min-height: var(--reseller-header-frame-height) !important;
          }

          body.dpn-app-reseller-template .site-header:not(.is-floating) .site-nav-item,
          body.dpn-app-reseller-template .site-header:not(.is-floating) .site-nav-link,
          body.dpn-app-reseller-template .site-header:not(.is-floating) .site-nav-menu > a,
          body.dpn-app-reseller-template .site-header:not(.is-floating) .site-icon,
          body.dpn-app-reseller-template .site-header.is-floating .site-nav-item,
          body.dpn-app-reseller-template .site-header.is-floating .site-nav-link,
          body.dpn-app-reseller-template .site-header.is-floating .site-nav-menu > a,
          body.dpn-app-reseller-template .site-header.is-floating .site-icon {
            box-sizing: border-box !important;
            min-height: 70px !important;
            height: 70px !important;
          }

          body.dpn-app-reseller-template .site-header:not(.is-floating) .site-dropdown.site-dropdown--products.site-dropdown--vpn-products,
          body.dpn-app-reseller-template .site-header:not(.is-floating) .site-dropdown.site-dropdown--products.site-dropdown--bundle-products,
          body.dpn-app-reseller-template .site-header.is-floating .site-dropdown.site-dropdown--products.site-dropdown--vpn-products,
          body.dpn-app-reseller-template .site-header.is-floating .site-dropdown.site-dropdown--products.site-dropdown--bundle-products {
            position: fixed !important;
            top: calc(var(--reseller-header-bottom, 102px) + var(--reseller-popover-gap)) !important;
            left: 50% !important;
            right: auto !important;
            max-width: calc(100vw - (var(--reseller-popover-edge) * 2)) !important;
            padding: var(--reseller-popover-pad) !important;
            border-radius: var(--reseller-popover-radius) !important;
            transform: translate3d(-50%, -8px, 0) scale(0.985) !important;
          }

          body.dpn-app-reseller-template .site-header .has-dropdown:hover > .site-dropdown.site-dropdown--products.site-dropdown--vpn-products,
          body.dpn-app-reseller-template .site-header .has-dropdown:focus-within > .site-dropdown.site-dropdown--products.site-dropdown--vpn-products,
          body.dpn-app-reseller-template .site-header .has-dropdown:hover > .site-dropdown.site-dropdown--products.site-dropdown--bundle-products,
          body.dpn-app-reseller-template .site-header .has-dropdown:focus-within > .site-dropdown.site-dropdown--products.site-dropdown--bundle-products {
            transform: translate3d(-50%, 0, 0) scale(1) !important;
          }

          body.dpn-app-reseller-template .site-header:not(.is-floating) .site-dropdown.site-dropdown--products.site-dropdown--vpn-products,
          body.dpn-app-reseller-template .site-header:not(.is-floating) .site-dropdown.site-dropdown--products.site-dropdown--bundle-products {
            color: #ffffff !important;
            border: 1px solid rgba(255, 255, 255, 0.12) !important;
            background: linear-gradient(180deg, #111318 0%, #05070d 100%) !important;
            box-shadow:
              0 30px 70px rgba(0, 0, 0, 0.36),
              inset 0 1px 0 rgba(255, 255, 255, 0.07) !important;
            backdrop-filter: none !important;
            -webkit-backdrop-filter: none !important;
          }

          body.dpn-app-reseller-template .site-header.is-floating .site-dropdown.site-dropdown--products.site-dropdown--vpn-products,
          body.dpn-app-reseller-template .site-header.is-floating .site-dropdown.site-dropdown--products.site-dropdown--bundle-products {
            color: #111318 !important;
            border: 1px solid rgba(126, 184, 255, 0.28) !important;
            background:
              radial-gradient(circle at 12% 0%, rgba(231, 245, 255, 0.9), transparent 38%),
              radial-gradient(circle at 90% 8%, rgba(37, 120, 255, 0.1), transparent 34%),
              linear-gradient(180deg, rgba(255, 255, 255, 0.98), rgba(247, 251, 255, 0.96)) !important;
            box-shadow:
              0 32px 84px rgba(15, 23, 42, 0.15),
              inset 0 1px 0 rgba(255, 255, 255, 0.9) !important;
            backdrop-filter: blur(24px) saturate(165%) !important;
            -webkit-backdrop-filter: blur(24px) saturate(165%) !important;
          }

          body.dpn-app-reseller-template .site-header:not(.is-floating) .site-dropdown.site-dropdown--products.site-dropdown--vpn-products .site-dropdown-inner,
          body.dpn-app-reseller-template .site-header:not(.is-floating) .site-dropdown.site-dropdown--products.site-dropdown--bundle-products .site-dropdown-inner {
            color: #ffffff !important;
          }

          body.dpn-app-reseller-template .site-header.is-floating .site-dropdown.site-dropdown--products.site-dropdown--vpn-products .site-dropdown-inner,
          body.dpn-app-reseller-template .site-header.is-floating .site-dropdown.site-dropdown--products.site-dropdown--bundle-products .site-dropdown-inner {
            color: #111318 !important;
          }

          body.dpn-app-reseller-template .site-header:not(.is-floating) .site-dropdown.site-dropdown--products .site-dropdown-group strong,
          body.dpn-app-reseller-template .site-header:not(.is-floating) .site-dropdown.site-dropdown--products .dropdown-product-title {
            color: rgba(255, 255, 255, 0.94) !important;
          }

          body.dpn-app-reseller-template .site-header:not(.is-floating) .site-dropdown.site-dropdown--products .site-dropdown-group a {
            color: rgba(255, 255, 255, 0.72) !important;
          }

          body.dpn-app-reseller-template .site-header.is-floating .site-dropdown.site-dropdown--products .site-dropdown-group strong,
          body.dpn-app-reseller-template .site-header.is-floating .site-dropdown.site-dropdown--products .dropdown-product-title {
            color: #111318 !important;
          }

          body.dpn-app-reseller-template .site-header.is-floating .site-dropdown.site-dropdown--products .site-dropdown-group a {
            color: rgba(17, 19, 24, 0.66) !important;
          }
        }
      `;
      document.head.appendChild(v151SpecificityStyle);

      const v17StrictHeaderParityStyle = document.createElement("style");
      v17StrictHeaderParityStyle.id = "dpn-reseller-strict-header-parity-v17";
      v17StrictHeaderParityStyle.textContent = `
        @media (min-width: 901px) {
          html body.dpn-app-reseller-template {
            --reseller-header-shell-y: 24px;
            --reseller-header-shell-height: 96px;
            --reseller-header-frame-height: 72px;
            --reseller-header-edge: 48px;
            --reseller-header-pad-x: 28px;
            --reseller-header-cols: 290px minmax(0, 1fr) 120px;
            --reseller-nav-gap: 24px;
            --reseller-nav-font-size: 16px;
            --reseller-nav-font-weight: 600;
            --reseller-popover-gap: 10px;
            --reseller-popover-edge: 48px;
            --reseller-popover-pad: 24px;
            --reseller-popover-radius: 26px;
            --reseller-small-popover-pad: 20px;
            --reseller-small-popover-radius: 22px;
            --reseller-product-card-width: 184px;
            --reseller-product-card-height: 266px;
            --reseller-product-image-height: 166px;
          }

          html body.dpn-app-reseller-template .site-header,
          html body.dpn-app-reseller-template .site-header:not(.is-floating),
          html body.dpn-app-reseller-template .site-header.is-floating {
            position: sticky !important;
            top: 0 !important;
            z-index: 320 !important;
            box-sizing: border-box !important;
            height: var(--reseller-header-shell-height) !important;
            min-height: var(--reseller-header-shell-height) !important;
            padding: var(--reseller-header-shell-y) 0 0 !important;
            color: inherit !important;
            overflow: visible !important;
            background: transparent !important;
            box-shadow: none !important;
            backdrop-filter: none !important;
            -webkit-backdrop-filter: none !important;
          }

          html body.dpn-app-reseller-template .site-header .site-header-inner,
          html body.dpn-app-reseller-template .site-header:not(.is-floating) .site-header-inner,
          html body.dpn-app-reseller-template .site-header.is-floating .site-header-inner {
            display: grid !important;
            grid-template-columns: var(--reseller-header-cols) !important;
            align-items: center !important;
            box-sizing: border-box !important;
            width: min(var(--nav-max), calc(100% - var(--reseller-header-edge))) !important;
            height: var(--reseller-header-frame-height) !important;
            min-height: var(--reseller-header-frame-height) !important;
            margin: 0 auto !important;
            padding: 0 var(--reseller-header-pad-x) !important;
            border-radius: 999px !important;
            transform: none !important;
            overflow: visible !important;
          }

          html body.dpn-app-reseller-template .site-header:not(.is-floating) .site-header-inner {
            color: #ffffff !important;
            border: 1px solid rgba(255, 255, 255, 0.16) !important;
            background: linear-gradient(180deg, #101318 0%, #05070d 100%) !important;
            box-shadow:
              0 18px 44px rgba(0, 0, 0, 0.22),
              inset 0 1px 0 rgba(255, 255, 255, 0.08) !important;
            backdrop-filter: none !important;
            -webkit-backdrop-filter: none !important;
          }

          html body.dpn-app-reseller-template .site-header.is-floating .site-header-inner {
            color: #121722 !important;
            border: 1px solid rgba(126, 184, 255, 0.36) !important;
            background: rgba(255, 255, 255, 0.78) !important;
            box-shadow:
              0 24px 72px rgba(15, 23, 42, 0.1),
              inset 0 10px 26px rgba(255, 255, 255, 0.36),
              inset 0 1px 0 rgba(255, 255, 255, 0.78) !important;
            backdrop-filter: blur(28px) saturate(180%) contrast(104%) !important;
            -webkit-backdrop-filter: blur(28px) saturate(180%) contrast(104%) !important;
          }

          html body.dpn-app-reseller-template .site-header:not(.is-floating) .site-header-inner::before,
          html body.dpn-app-reseller-template .site-header:not(.is-floating) .site-header-inner::after,
          html body.dpn-app-reseller-template .site-header:not(.is-floating) .header-edge-light {
            display: none !important;
            opacity: 0 !important;
          }

          html body.dpn-app-reseller-template .site-header .site-nav-menu,
          html body.dpn-app-reseller-template .site-header:not(.is-floating) .site-nav-menu,
          html body.dpn-app-reseller-template .site-header.is-floating .site-nav-menu {
            gap: var(--reseller-nav-gap) !important;
            color: inherit !important;
            font-size: var(--reseller-nav-font-size) !important;
            line-height: 22px !important;
            font-weight: var(--reseller-nav-font-weight) !important;
          }

          html body.dpn-app-reseller-template .site-header .site-nav-item,
          html body.dpn-app-reseller-template .site-header .site-nav-link,
          html body.dpn-app-reseller-template .site-header .site-nav-menu > a,
          html body.dpn-app-reseller-template .site-header .site-icon,
          html body.dpn-app-reseller-template .site-header:not(.is-floating) .site-nav-item,
          html body.dpn-app-reseller-template .site-header:not(.is-floating) .site-nav-link,
          html body.dpn-app-reseller-template .site-header:not(.is-floating) .site-nav-menu > a,
          html body.dpn-app-reseller-template .site-header:not(.is-floating) .site-icon,
          html body.dpn-app-reseller-template .site-header.is-floating .site-nav-item,
          html body.dpn-app-reseller-template .site-header.is-floating .site-nav-link,
          html body.dpn-app-reseller-template .site-header.is-floating .site-nav-menu > a,
          html body.dpn-app-reseller-template .site-header.is-floating .site-icon {
            box-sizing: border-box !important;
            min-height: var(--reseller-header-frame-height) !important;
            height: var(--reseller-header-frame-height) !important;
            padding-top: 0 !important;
            padding-bottom: 0 !important;
            color: inherit !important;
            font-size: var(--reseller-nav-font-size) !important;
            line-height: 22px !important;
            font-weight: var(--reseller-nav-font-weight) !important;
          }

          html body.dpn-app-reseller-template .site-header:not(.is-floating) .site-logo img {
            filter: brightness(0) invert(1) grayscale(1) !important;
          }

          html body.dpn-app-reseller-template .site-header.is-floating .site-logo img {
            filter: none !important;
          }

          html body.dpn-app-reseller-template .site-header .site-dropdown.site-dropdown--products,
          html body.dpn-app-reseller-template .site-header:not(.is-floating) .site-dropdown.site-dropdown--products,
          html body.dpn-app-reseller-template .site-header.is-floating .site-dropdown.site-dropdown--products {
            position: fixed !important;
            top: calc(var(--reseller-header-bottom, 106px) + var(--reseller-popover-gap)) !important;
            left: 50% !important;
            right: auto !important;
            box-sizing: border-box !important;
            max-width: calc(100vw - (var(--reseller-popover-edge) * 2)) !important;
            padding: var(--reseller-popover-pad) !important;
            border-radius: var(--reseller-popover-radius) !important;
            transform: translate3d(-50%, -8px, 0) scale(0.985) !important;
          }

          html body.dpn-app-reseller-template .site-header .has-dropdown:hover > .site-dropdown.site-dropdown--products,
          html body.dpn-app-reseller-template .site-header .has-dropdown:focus-within > .site-dropdown.site-dropdown--products {
            transform: translate3d(-50%, 0, 0) scale(1) !important;
          }

          html body.dpn-app-reseller-template .site-header .site-dropdown.site-dropdown--products.site-dropdown--vpn-products {
            width: min(1320px, calc(100vw - (var(--reseller-popover-edge) * 2))) !important;
          }

          html body.dpn-app-reseller-template .site-header .site-dropdown.site-dropdown--products.site-dropdown--bundle-products {
            width: min(960px, calc(100vw - (var(--reseller-popover-edge) * 2))) !important;
          }

          html body.dpn-app-reseller-template .site-header:not(.is-floating) .site-dropdown.site-dropdown--products {
            color: #ffffff !important;
            border: 1px solid rgba(255, 255, 255, 0.12) !important;
            background: linear-gradient(180deg, #111318 0%, #05070d 100%) !important;
            box-shadow:
              0 30px 70px rgba(0, 0, 0, 0.36),
              inset 0 1px 0 rgba(255, 255, 255, 0.07) !important;
            backdrop-filter: none !important;
            -webkit-backdrop-filter: none !important;
          }

          html body.dpn-app-reseller-template .site-header.is-floating .site-dropdown.site-dropdown--products {
            color: #111318 !important;
            border: 1px solid rgba(126, 184, 255, 0.28) !important;
            background:
              radial-gradient(circle at 12% 0%, rgba(231, 245, 255, 0.9), transparent 38%),
              radial-gradient(circle at 90% 8%, rgba(37, 120, 255, 0.1), transparent 34%),
              linear-gradient(180deg, rgba(255, 255, 255, 0.98), rgba(247, 251, 255, 0.96)) !important;
            box-shadow:
              0 32px 84px rgba(15, 23, 42, 0.15),
              inset 0 1px 0 rgba(255, 255, 255, 0.9) !important;
            backdrop-filter: blur(24px) saturate(165%) !important;
            -webkit-backdrop-filter: blur(24px) saturate(165%) !important;
          }

          html body.dpn-app-reseller-template .site-header .site-dropdown.site-dropdown--products .site-dropdown-inner,
          html body.dpn-app-reseller-template .site-header:not(.is-floating) .site-dropdown.site-dropdown--products .site-dropdown-inner,
          html body.dpn-app-reseller-template .site-header.is-floating .site-dropdown.site-dropdown--products .site-dropdown-inner {
            box-sizing: border-box !important;
            display: grid !important;
            gap: 24px !important;
            width: 100% !important;
            padding: 0 !important;
            border: 0 !important;
            border-radius: calc(var(--reseller-popover-radius) - 4px) !important;
            background: transparent !important;
            box-shadow: none !important;
          }

          html body.dpn-app-reseller-template .site-header .site-dropdown.site-dropdown--products.site-dropdown--vpn-products .site-dropdown-inner {
            grid-template-columns: 244px minmax(0, 1fr) !important;
          }

          html body.dpn-app-reseller-template .site-header .site-dropdown.site-dropdown--products.site-dropdown--bundle-products .site-dropdown-inner {
            grid-template-columns: 244px minmax(0, 1fr) !important;
          }

          html body.dpn-app-reseller-template .site-header .site-dropdown.site-dropdown--products .dropdown-product-grid,
          html body.dpn-app-reseller-template .site-header .site-dropdown.site-dropdown--products .dropdown-product-grid--vpn,
          html body.dpn-app-reseller-template .site-header .site-dropdown.site-dropdown--products .dropdown-product-grid--bundles {
            gap: 18px !important;
            align-items: stretch !important;
            justify-content: center !important;
          }

          html body.dpn-app-reseller-template .site-header .site-dropdown.site-dropdown--products .dropdown-product-card,
          html body.dpn-app-reseller-template .site-header:not(.is-floating) .site-dropdown.site-dropdown--products .dropdown-product-card,
          html body.dpn-app-reseller-template .site-header.is-floating .site-dropdown.site-dropdown--products .dropdown-product-card {
            box-sizing: border-box !important;
            display: flex !important;
            flex-direction: column !important;
            justify-content: space-between !important;
            width: var(--reseller-product-card-width) !important;
            min-height: var(--reseller-product-card-height) !important;
            height: var(--reseller-product-card-height) !important;
            padding: 0 !important;
            border-radius: 14px !important;
            overflow: hidden !important;
            text-align: center !important;
            text-decoration: none !important;
          }

          html body.dpn-app-reseller-template .site-header .site-dropdown.site-dropdown--products .dropdown-product-image,
          html body.dpn-app-reseller-template .site-header:not(.is-floating) .site-dropdown.site-dropdown--products .dropdown-product-image,
          html body.dpn-app-reseller-template .site-header.is-floating .site-dropdown.site-dropdown--products .dropdown-product-image {
            display: grid !important;
            height: var(--reseller-product-image-height) !important;
            padding: 20px 16px 0 !important;
            place-items: center !important;
            overflow: hidden !important;
            border-radius: 0 !important;
            background: transparent !important;
          }

          html body.dpn-app-reseller-template .site-header .site-dropdown.site-dropdown--products .dropdown-product-title,
          html body.dpn-app-reseller-template .site-header:not(.is-floating) .site-dropdown.site-dropdown--products .dropdown-product-title,
          html body.dpn-app-reseller-template .site-header.is-floating .site-dropdown.site-dropdown--products .dropdown-product-title {
            max-width: 160px !important;
            min-height: 38px !important;
            margin: 0 auto !important;
            color: inherit !important;
            font-size: 16px !important;
            line-height: 1.12 !important;
            font-weight: 500 !important;
            text-align: center !important;
          }

          html body.dpn-app-reseller-template .site-header .site-dropdown:not(.site-dropdown--products) {
            position: fixed !important;
            top: calc(var(--reseller-header-bottom, 106px) + var(--reseller-popover-gap)) !important;
            left: 50% !important;
            right: auto !important;
            box-sizing: border-box !important;
            width: auto !important;
            min-width: 260px !important;
            max-width: calc(100vw - (var(--reseller-popover-edge) * 2)) !important;
            padding: 0 !important;
            border-radius: var(--reseller-small-popover-radius) !important;
            transform: translate3d(-50%, -8px, 0) scale(0.985) !important;
          }

          html body.dpn-app-reseller-template .site-header .has-dropdown:hover > .site-dropdown:not(.site-dropdown--products),
          html body.dpn-app-reseller-template .site-header .has-dropdown:focus-within > .site-dropdown:not(.site-dropdown--products) {
            transform: translate3d(-50%, 0, 0) scale(1) !important;
          }

          html body.dpn-app-reseller-template .site-header .site-dropdown--wide,
          html body.dpn-app-reseller-template .site-header .site-dropdown--guide {
            min-width: 720px !important;
          }

          html body.dpn-app-reseller-template .site-header .site-dropdown:not(.site-dropdown--products) .site-dropdown-inner,
          html body.dpn-app-reseller-template .site-header:not(.is-floating) .site-dropdown:not(.site-dropdown--products) .site-dropdown-inner,
          html body.dpn-app-reseller-template .site-header.is-floating .site-dropdown:not(.site-dropdown--products) .site-dropdown-inner {
            box-sizing: border-box !important;
            padding: var(--reseller-small-popover-pad) !important;
            border-radius: var(--reseller-small-popover-radius) !important;
            gap: 16px !important;
            font-size: 14px !important;
            line-height: 1.42 !important;
            font-weight: 500 !important;
          }

          html body.dpn-app-reseller-template .site-header:not(.is-floating) .site-dropdown:not(.site-dropdown--products) .site-dropdown-inner {
            color: #ffffff !important;
            border: 1px solid rgba(255, 255, 255, 0.12) !important;
            background: linear-gradient(180deg, #111318 0%, #05070d 100%) !important;
            box-shadow: 0 28px 62px rgba(0, 0, 0, 0.32) !important;
          }

          html body.dpn-app-reseller-template .site-header.is-floating .site-dropdown:not(.site-dropdown--products) .site-dropdown-inner {
            color: #111318 !important;
            border: 1px solid rgba(126, 184, 255, 0.28) !important;
            background: rgba(255, 255, 255, 0.96) !important;
            box-shadow: 0 28px 62px rgba(15, 23, 42, 0.12) !important;
            backdrop-filter: blur(22px) saturate(165%) !important;
            -webkit-backdrop-filter: blur(22px) saturate(165%) !important;
          }
        }
      `;
      document.head.appendChild(v17StrictHeaderParityStyle);

      const v18HeaderMenuCorrectionStyle = document.createElement("style");
      v18HeaderMenuCorrectionStyle.id = "dpn-reseller-header-menu-correction-v18";
      v18HeaderMenuCorrectionStyle.textContent = `
        @media (min-width: 901px) {
          html body.dpn-app-reseller-template {
            --reseller-nav-font-size: 16px;
            --reseller-nav-font-weight: 600;
            --reseller-product-card-width: 184px;
            --reseller-product-card-height: 266px;
            --reseller-product-image-height: 166px;
            --reseller-popover-radius: 26px;
            --reseller-popover-pad: 24px;
            --reseller-small-menu-gap: 8px;
          }

          html body.dpn-app-reseller-template .site-header:not(.is-floating) {
            height: 75px !important;
            min-height: 75px !important;
            padding: 0 !important;
            color: #fff !important;
            background: #000 !important;
            box-shadow: none !important;
            backdrop-filter: none !important;
            -webkit-backdrop-filter: none !important;
          }

          html body.dpn-app-reseller-template .site-header:not(.is-floating) .site-header-inner {
            display: grid !important;
            grid-template-columns: 290px minmax(0, 1fr) 120px !important;
            align-items: center !important;
            width: min(var(--nav-max), calc(100% - 112px)) !important;
            height: 74px !important;
            min-height: 74px !important;
            margin: 0 auto !important;
            padding: 0 !important;
            border: 0 !important;
            border-radius: 0 !important;
            color: #fff !important;
            background: transparent !important;
            box-shadow: none !important;
            transform: none !important;
            backdrop-filter: none !important;
            -webkit-backdrop-filter: none !important;
          }

          html body.dpn-app-reseller-template .site-header.is-floating {
            height: 102px !important;
            min-height: 102px !important;
            padding: 30px 0 0 !important;
            background: transparent !important;
            box-shadow: none !important;
          }

          html body.dpn-app-reseller-template .site-header.is-floating .site-header-inner {
            display: grid !important;
            grid-template-columns: 290px minmax(0, 1fr) 120px !important;
            align-items: center !important;
            width: min(var(--nav-max), calc(100% - 72px)) !important;
            height: 72px !important;
            min-height: 72px !important;
            margin: 0 auto !important;
            padding: 0 28px !important;
            border: 1px solid rgba(126, 184, 255, 0.36) !important;
            border-radius: 999px !important;
            color: #121722 !important;
            background: rgba(255, 255, 255, 0.78) !important;
            box-shadow:
              0 24px 72px rgba(15, 23, 42, 0.1),
              inset 0 10px 26px rgba(255, 255, 255, 0.36),
              inset 0 1px 0 rgba(255, 255, 255, 0.78) !important;
            backdrop-filter: blur(28px) saturate(180%) contrast(104%) !important;
            -webkit-backdrop-filter: blur(28px) saturate(180%) contrast(104%) !important;
          }

          html body.dpn-app-reseller-template .site-header .site-nav-menu,
          html body.dpn-app-reseller-template .site-header .site-nav-link,
          html body.dpn-app-reseller-template .site-header .site-nav-menu > a,
          html body.dpn-app-reseller-template .site-header .site-icon,
          html body.dpn-app-reseller-template .site-header .site-nav-item {
            color: inherit !important;
            font-size: var(--reseller-nav-font-size) !important;
            line-height: 22px !important;
            font-weight: var(--reseller-nav-font-weight) !important;
          }

          html body.dpn-app-reseller-template .site-header:not(.is-floating) .site-nav-link,
          html body.dpn-app-reseller-template .site-header:not(.is-floating) .site-nav-menu > a,
          html body.dpn-app-reseller-template .site-header:not(.is-floating) .site-icon,
          html body.dpn-app-reseller-template .site-header:not(.is-floating) .site-nav-item {
            height: 74px !important;
            min-height: 74px !important;
          }

          html body.dpn-app-reseller-template .site-header.is-floating .site-nav-link,
          html body.dpn-app-reseller-template .site-header.is-floating .site-nav-menu > a,
          html body.dpn-app-reseller-template .site-header.is-floating .site-icon,
          html body.dpn-app-reseller-template .site-header.is-floating .site-nav-item {
            height: 72px !important;
            min-height: 72px !important;
          }

          html body.dpn-app-reseller-template .site-nav-item--guide {
            flex: 0 0 auto !important;
            width: auto !important;
            max-width: 210px !important;
          }

          html body.dpn-app-reseller-template .site-nav-item--guide .site-nav-link {
            width: 198px !important;
            max-width: 198px !important;
            padding: 0 !important;
            border: 0 !important;
            background: transparent !important;
            box-shadow: none !important;
            text-align: center !important;
            white-space: normal !important;
            text-wrap: balance !important;
          }

          html body.dpn-app-reseller-template .site-header:not(.is-floating) .site-logo img,
          html body.dpn-app-reseller-template .site-header.is-floating .site-logo img {
            filter: none !important;
          }

          html body.dpn-app-reseller-template .site-header .site-dropdown.site-dropdown--products,
          html body.dpn-app-reseller-template .site-header:not(.is-floating) .site-dropdown.site-dropdown--products,
          html body.dpn-app-reseller-template .site-header.is-floating .site-dropdown.site-dropdown--products {
            position: fixed !important;
            left: 50% !important;
            right: auto !important;
            top: calc(var(--reseller-header-bottom, 102px) + 10px) !important;
            box-sizing: border-box !important;
            padding: var(--reseller-popover-pad) !important;
            border-radius: var(--reseller-popover-radius) !important;
            transform: translate3d(-50%, -8px, 0) scale(0.985) !important;
          }

          html body.dpn-app-reseller-template .site-header .has-dropdown:hover > .site-dropdown.site-dropdown--products,
          html body.dpn-app-reseller-template .site-header .has-dropdown:focus-within > .site-dropdown.site-dropdown--products {
            transform: translate3d(-50%, 0, 0) scale(1) !important;
          }

          html body.dpn-app-reseller-template .site-header .site-dropdown.site-dropdown--products.site-dropdown--vpn-products {
            width: min(1320px, calc(100vw - 96px)) !important;
          }

          html body.dpn-app-reseller-template .site-header .site-dropdown.site-dropdown--products.site-dropdown--bundle-products {
            width: min(960px, calc(100vw - 96px)) !important;
          }

          html body.dpn-app-reseller-template .site-header .site-dropdown.site-dropdown--products .site-dropdown-inner {
            display: grid !important;
            width: 100% !important;
            gap: 24px !important;
            padding: 0 !important;
            border: 0 !important;
            border-radius: 22px !important;
            color: inherit !important;
            background: transparent !important;
            box-shadow: none !important;
          }

          html body.dpn-app-reseller-template .site-header .site-dropdown.site-dropdown--products.site-dropdown--vpn-products .site-dropdown-inner,
          html body.dpn-app-reseller-template .site-header .site-dropdown.site-dropdown--products.site-dropdown--bundle-products .site-dropdown-inner {
            grid-template-columns: 244px minmax(0, 1fr) !important;
          }

          html body.dpn-app-reseller-template .site-header .site-dropdown.site-dropdown--products .site-dropdown-group {
            display: grid !important;
            gap: 10px !important;
            align-content: start !important;
          }

          html body.dpn-app-reseller-template .site-header .site-dropdown.site-dropdown--products .site-dropdown-group strong,
          html body.dpn-app-reseller-template .site-header:not(.is-floating) .site-dropdown.site-dropdown--products .site-dropdown-group strong,
          html body.dpn-app-reseller-template .site-header.is-floating .site-dropdown.site-dropdown--products .site-dropdown-group strong {
            margin: 0 0 4px !important;
            font-size: 22px !important;
            line-height: 1.18 !important;
            font-weight: 700 !important;
            letter-spacing: 0 !important;
          }

          html body.dpn-app-reseller-template .site-header .site-dropdown.site-dropdown--products .site-dropdown-group a,
          html body.dpn-app-reseller-template .site-header:not(.is-floating) .site-dropdown.site-dropdown--products .site-dropdown-group a,
          html body.dpn-app-reseller-template .site-header.is-floating .site-dropdown.site-dropdown--products .site-dropdown-group a {
            font-size: 16px !important;
            line-height: 1.45 !important;
            font-weight: 400 !important;
            letter-spacing: 0 !important;
          }

          html body.dpn-app-reseller-template .site-header .site-dropdown.site-dropdown--products .dropdown-product-grid,
          html body.dpn-app-reseller-template .site-header .site-dropdown.site-dropdown--products .dropdown-product-grid--vpn,
          html body.dpn-app-reseller-template .site-header .site-dropdown.site-dropdown--products .dropdown-product-grid--bundles {
            gap: 18px !important;
            align-items: start !important;
            justify-content: center !important;
            justify-items: center !important;
          }

          html body.dpn-app-reseller-template .site-header .site-dropdown.site-dropdown--products .dropdown-product-card,
          html body.dpn-app-reseller-template .site-header .site-dropdown.site-dropdown--products.site-dropdown--vpn-products .dropdown-product-grid.dropdown-product-grid--vpn > .dropdown-product-card,
          html body.dpn-app-reseller-template .site-header:not(.is-floating) .site-dropdown.site-dropdown--products .dropdown-product-card,
          html body.dpn-app-reseller-template .site-header.is-floating .site-dropdown.site-dropdown--products .dropdown-product-card {
            justify-self: center !important;
            flex: 0 0 var(--reseller-product-card-width) !important;
            width: var(--reseller-product-card-width) !important;
            min-width: var(--reseller-product-card-width) !important;
            max-width: var(--reseller-product-card-width) !important;
            height: var(--reseller-product-card-height) !important;
            min-height: var(--reseller-product-card-height) !important;
            max-height: var(--reseller-product-card-height) !important;
            padding: 0 !important;
            border-radius: 14px !important;
            overflow: hidden !important;
          }

          html body.dpn-app-reseller-template .site-header .site-dropdown.site-dropdown--products .dropdown-product-image,
          html body.dpn-app-reseller-template .site-header:not(.is-floating) .site-dropdown.site-dropdown--products .dropdown-product-image,
          html body.dpn-app-reseller-template .site-header.is-floating .site-dropdown.site-dropdown--products .dropdown-product-image {
            height: var(--reseller-product-image-height) !important;
            padding: 20px 16px 0 !important;
            border-radius: 0 !important;
            background: transparent !important;
          }

          html body.dpn-app-reseller-template .site-header .site-dropdown.site-dropdown--products .dropdown-product-title,
          html body.dpn-app-reseller-template .site-header .site-dropdown.site-dropdown--products.site-dropdown--vpn-products .dropdown-product-grid.dropdown-product-grid--vpn > .dropdown-product-card .dropdown-product-title,
          html body.dpn-app-reseller-template .site-header:not(.is-floating) .site-dropdown.site-dropdown--products .dropdown-product-title,
          html body.dpn-app-reseller-template .site-header.is-floating .site-dropdown.site-dropdown--products .dropdown-product-title {
            max-width: 160px !important;
            min-height: 38px !important;
            margin: 0 auto !important;
            padding: 0 !important;
            font-size: 16px !important;
            line-height: 1.12 !important;
            font-weight: 600 !important;
            letter-spacing: 0 !important;
            text-align: center !important;
            color: inherit !important;
          }

          html body.dpn-app-reseller-template .site-header .site-dropdown.site-dropdown--products .dropdown-product-subtitle,
          html body.dpn-app-reseller-template .site-header:not(.is-floating) .site-dropdown.site-dropdown--products .dropdown-product-subtitle,
          html body.dpn-app-reseller-template .site-header.is-floating .site-dropdown.site-dropdown--products .dropdown-product-subtitle {
            max-width: 164px !important;
            font-size: 13px !important;
            line-height: 1.18 !important;
            font-weight: 400 !important;
            letter-spacing: 0 !important;
            text-align: center !important;
          }

          html body.dpn-app-reseller-template .site-header:not(.is-floating) .site-dropdown.site-dropdown--products {
            color: #fff !important;
            border: 1px solid rgba(255, 255, 255, 0.12) !important;
            background: linear-gradient(180deg, #111318 0%, #05070d 100%) !important;
          }

          html body.dpn-app-reseller-template .site-header.is-floating .site-dropdown.site-dropdown--products {
            color: #111318 !important;
            border: 1px solid rgba(126, 184, 255, 0.28) !important;
          }

          html body.dpn-app-reseller-template .site-header:not(.is-floating) .site-dropdown.site-dropdown--products .site-dropdown-group strong,
          html body.dpn-app-reseller-template .site-header:not(.is-floating) .site-dropdown.site-dropdown--products .dropdown-product-title {
            color: rgba(255, 255, 255, 0.94) !important;
          }

          html body.dpn-app-reseller-template .site-header:not(.is-floating) .site-dropdown.site-dropdown--products .site-dropdown-group a,
          html body.dpn-app-reseller-template .site-header:not(.is-floating) .site-dropdown.site-dropdown--products .dropdown-product-subtitle {
            color: rgba(255, 255, 255, 0.68) !important;
          }

          html body.dpn-app-reseller-template .site-header.is-floating .site-dropdown.site-dropdown--products .site-dropdown-group strong,
          html body.dpn-app-reseller-template .site-header.is-floating .site-dropdown.site-dropdown--products .dropdown-product-title {
            color: #111318 !important;
          }

          html body.dpn-app-reseller-template .site-header.is-floating .site-dropdown.site-dropdown--products .site-dropdown-group a,
          html body.dpn-app-reseller-template .site-header.is-floating .site-dropdown.site-dropdown--products .dropdown-product-subtitle {
            color: rgba(17, 19, 24, 0.54) !important;
          }

          html body.dpn-app-reseller-template .site-header .site-nav-item.has-dropdown > .site-dropdown:not(.site-dropdown--products) {
            position: absolute !important;
            top: calc(100% + var(--reseller-small-menu-gap)) !important;
            left: 50% !important;
            right: auto !important;
            min-width: 260px !important;
            width: max-content !important;
            max-width: min(720px, calc(100vw - 64px)) !important;
            padding: 0 !important;
            border-radius: 22px !important;
            transform: translate3d(-50%, -8px, 0) scale(0.985) !important;
          }

          html body.dpn-app-reseller-template .site-header .site-nav-item.has-dropdown:hover > .site-dropdown:not(.site-dropdown--products),
          html body.dpn-app-reseller-template .site-header .site-nav-item.has-dropdown:focus-within > .site-dropdown:not(.site-dropdown--products) {
            transform: translate3d(-50%, 0, 0) scale(1) !important;
          }

          html body.dpn-app-reseller-template .site-header .site-dropdown--guide {
            min-width: 340px !important;
            max-width: 420px !important;
          }

          html body.dpn-app-reseller-template .site-header .site-dropdown--wide {
            min-width: 640px !important;
            max-width: 720px !important;
          }

          html body.dpn-app-reseller-template .site-header .site-dropdown:not(.site-dropdown--products) .site-dropdown-inner,
          html body.dpn-app-reseller-template .site-header:not(.is-floating) .site-dropdown:not(.site-dropdown--products) .site-dropdown-inner,
          html body.dpn-app-reseller-template .site-header.is-floating .site-dropdown:not(.site-dropdown--products) .site-dropdown-inner {
            padding: 22px !important;
            border-radius: 22px !important;
            gap: 14px !important;
            font-size: 14px !important;
            line-height: 1.45 !important;
            font-weight: 500 !important;
          }
        }
      `;
      document.head.appendChild(v18HeaderMenuCorrectionStyle);

      const finalNavStylesheet = Array.from(document.querySelectorAll('link[rel="stylesheet"]'))
        .find(function (link) {
          return /dpn-app-reseller-page-live-20260706-rounded-popovers-v(13|14)\.css/.test(link.href || "");
        });
      if (finalNavStylesheet && !document.getElementById("dpn-reseller-final-nav-lock-v19")) {
        const finalNavLock = document.createElement("link");
        finalNavLock.id = "dpn-reseller-final-nav-lock-v19";
        finalNavLock.rel = "stylesheet";
        const finalNavHref = finalNavStylesheet.href.replace(
          /dpn-app-reseller-page-live-20260706-rounded-popovers-v(?:13|14)\.css(?:\?.*)?$/,
          "dpn-app-reseller-page-nav-final-v19.css"
        );
        finalNavLock.href = finalNavHref + (finalNavHref.includes("?") ? "&" : "?") + "navlock=20260706v20";
        document.head.appendChild(finalNavLock);
      }

      function updateHeader() {
        if (!siteHeader) return;
        siteHeader.classList.toggle("is-floating", window.scrollY > 34);
        document.documentElement.style.setProperty("--reseller-header-bottom", Math.ceil(siteHeader.getBoundingClientRect().bottom) + "px");
      }

      updateHeader();
      window.addEventListener("scroll", updateHeader, { passive: true });
      window.addEventListener("resize", updateHeader, { passive: true });

      const navItems = Array.from(document.querySelectorAll(".has-dropdown"));
      navItems.forEach(function (item) {
        const trigger = item.querySelector(".site-nav-link");
        if (!trigger) return;

        function setOpen(isOpen) {
          trigger.setAttribute("aria-expanded", isOpen ? "true" : "false");
        }

        item.addEventListener("pointerenter", function () { setOpen(true); });
        item.addEventListener("pointerleave", function () { setOpen(false); });
        item.addEventListener("focusin", function () { setOpen(true); });
        item.addEventListener("focusout", function (event) {
          if (!item.contains(event.relatedTarget)) setOpen(false);
        });
        item.addEventListener("keydown", function (event) {
          if (event.key === "Escape") {
            setOpen(false);
            trigger.focus();
          }
        });
      });

      if (headerInner && !prefersReducedMotion) {
        function setHeaderGlow(edge, angle) {
          headerInner.style.setProperty("--edge-proximity", edge.toFixed(3));
          headerInner.style.setProperty("--cursor-angle", angle.toFixed(3) + "deg");
        }

        function getHeaderPointerMetrics(event) {
          const rect = headerInner.getBoundingClientRect();
          const x = event.clientX - rect.left;
          const y = event.clientY - rect.top;
          const cx = rect.width / 2;
          const cy = rect.height / 2;
          const dx = x - cx;
          const dy = y - cy;
          const kx = dx === 0 ? Infinity : cx / Math.abs(dx);
          const ky = dy === 0 ? Infinity : cy / Math.abs(dy);
          const edge = Math.min(Math.max(1 / Math.min(kx, ky), 0), 1) * 100;
          let angle = Math.atan2(dy, dx) * (180 / Math.PI) + 90;
          if (angle < 0) angle += 360;
          return { edge, angle };
        }

        headerInner.addEventListener("pointermove", function (event) {
          if (!siteHeader.classList.contains("is-floating")) return;
          const metrics = getHeaderPointerMetrics(event);
          setHeaderGlow(metrics.edge, metrics.angle);
        });

        headerInner.addEventListener("pointerleave", function () {
          setHeaderGlow(0, 45);
        });
      }

      const hero = document.querySelector(".hero");
      if (hero && !prefersReducedMotion) {
        let frame = 0;
        let targetX = 50;
        let targetY = 45;
        let currentX = 50;
        let currentY = 45;

        function renderHeroPointer() {
          currentX += (targetX - currentX) * 0.16;
          currentY += (targetY - currentY) * 0.16;

          hero.style.setProperty("--mx", currentX.toFixed(2) + "%");
          hero.style.setProperty("--my", currentY.toFixed(2) + "%");
          hero.style.setProperty("--hero-drift-x", ((currentX - 50) * 0.18).toFixed(2) + "px");
          hero.style.setProperty("--hero-drift-y", ((currentY - 50) * 0.14).toFixed(2) + "px");

          if (Math.abs(targetX - currentX) > 0.04 || Math.abs(targetY - currentY) > 0.04) {
            frame = window.requestAnimationFrame(renderHeroPointer);
          } else {
            frame = 0;
          }
        }

        function queueHeroPointer() {
          if (!frame) {
            frame = window.requestAnimationFrame(renderHeroPointer);
          }
        }

        hero.addEventListener("pointermove", function (event) {
          const rect = hero.getBoundingClientRect();
          targetX = Math.min(Math.max(((event.clientX - rect.left) / rect.width) * 100, 0), 100);
          targetY = Math.min(Math.max(((event.clientY - rect.top) / rect.height) * 100, 0), 100);
          queueHeroPointer();
        }, { passive: true });

        hero.addEventListener("pointerleave", function () {
          targetX = 50;
          targetY = 45;
          queueHeroPointer();
        });
      }

      const heroMainVideo = document.querySelector(".hero-main-video");
      const heroLoopVideo = document.querySelector(".hero-loop-video");
      if (hero && heroMainVideo && heroLoopVideo && !prefersReducedMotion) {
        let loopStarted = false;
        let loopHydrated = false;

        function hydrateLoopVideo() {
          if (loopHydrated) return;
          const src = heroLoopVideo.getAttribute("data-src");
          if (!src) return;
          loopHydrated = true;
          heroLoopVideo.src = src;
          heroLoopVideo.load();
        }

        function activateLoopVideo() {
          try {
            heroLoopVideo.currentTime = 0;
          } catch (error) {}
          heroLoopVideo.classList.add("is-active");
          hero.classList.add("is-video-looping");
          heroLoopVideo.play().catch(function () {});
          heroMainVideo.pause();
        }

        function startHandshakeLoop() {
          if (loopStarted) return;
          loopStarted = true;
          hydrateLoopVideo();

          if (heroLoopVideo.readyState >= 2) {
            activateLoopVideo();
          } else {
            heroLoopVideo.addEventListener("canplay", activateLoopVideo, { once: true });
          }
        }

        heroMainVideo.addEventListener("ended", startHandshakeLoop);

        heroMainVideo.addEventListener("loadedmetadata", function () {
          const duration = Number.isFinite(heroMainVideo.duration) ? heroMainVideo.duration : 7;
          const delay = Math.max(1800, (duration - 2) * 1000);
          window.setTimeout(hydrateLoopVideo, delay);
        }, { once: true });

        document.addEventListener("visibilitychange", function () {
          if (document.hidden) {
            heroMainVideo.pause();
            heroLoopVideo.pause();
          } else if (loopStarted) {
            hydrateLoopVideo();
            heroLoopVideo.play().catch(function () {});
          } else {
            heroMainVideo.play().catch(function () {});
          }
        });
      }

      const revealItems = Array.from(document.querySelectorAll(".reveal"));
      if ("IntersectionObserver" in window) {
        const observer = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add("is-visible");
              observer.unobserve(entry.target);
            }
          });
        }, { threshold: 0.16, rootMargin: "0px 0px -8% 0px" });
        revealItems.forEach(function (item) { observer.observe(item); });
      } else {
        revealItems.forEach(function (item) { item.classList.add("is-visible"); });
      }
    });
